<template>
  <div
    id="app"
    class="container"
  >
    <transition :name="transitionName">
      <router-view v-show="loaded" />
    </transition>
    <div
      class="loading"
      v-if="!loaded"
    >
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-red text-align--center"></i>
    </div>
    <b-modal
      v-model="errorModal"
      v-if="apiError"
    >
      <div slot="modal-header">{{apiError.response.status}} - {{errorId}}</div>
      <h1>Virhe!</h1>Tilauksen hakeminen tilausnumerolla epäonnistui.
      <br>Jos tämä virhe toistuu, ota yhteyttä Toyotaan.
      <div slot="modal-footer">
        <b-button
          @click="errorModal = false"
          class="btn-t1-secondary"
        >Peruuta</b-button>
        <b-button
          variant="danger"
          :href="errorMail"
          class="btn-t1-primary"
        >Ota yhteyttä</b-button>
      </div>
    </b-modal>
    <b-modal
      v-model="defaultsModal"
      v-if="defaultsModal"
    >
      <div slot="modal-header">Et ole tehnyt muutoksia.</div>
      <p>Et ole muuttanut yhtään asetusta, joten ajoneuvosi luovutetaan tällöin oletusasetuksilla.</p>
      <div slot="modal-footer">
        <b-button
          @click="defaultsModal = false"
          class="btn-t1-secondary"
        >Palaa lomakkeeseen</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Bus from "./bus";
import analytics from "./helpers/analytics";
export default {
  data() {
    return {
      transitionName: "",
      apiError: null,
      errorModal: false,
      defaultsModal: false
    };
  },
  methods: {
    ...mapActions({
      loadTemplates: "loadTemplates",
      loadCars: "loadCars",
      loadDealers: "loadDealers"
    })
  },
  computed: {
    ...mapGetters({
      templatesLoaded: "templatesLoaded",
      carsLoaded: "carsLoaded",
      dealersLoaded: "dealersLoaded"
    }),
    loaded() {
      return (
        this.templatesLoaded && this.carsLoaded && this.dealersLoaded === true
      );
    },
    errorId() {
      if (this.apiError) {
        let id = this.apiError.response.config.url.split("/");
        return id[id.length - 1];
      }
    },
    errorMail() {
      let mail = [];
      mail.push(
        "mailto:info@toyota.fi?subject=Virhe personointisivulla: " +
          this.errorId
      );
      mail.push(
        "body=Tietoja virheestä: " +
          this.apiError.response.config.url +
          "%0D%0A" +
          Date.now() +
          "%0D%0A" +
          "Voit lisätä lisätietoja alle:" +
          "%0D%0A"
      );
      mail = mail.join("&");
      return mail;
    }
  },
  mounted() {
    this.loadDealers();
    this.loadCars();
    this.loadTemplates();
    Bus.$on("apiError", error => {
      this.apiError = error;
      this.errorModal = true;
    });
    Bus.$on("onlyDefaults", () => {
      this.defaultsModal = true;
    });
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    }
  }
};
</script>

<style lang="scss">
body {
  background-image: url("./assets/car-bg.png");
  background-repeat: repeat-x;
  .btn-t1-secondary {
    &:hover {
      color: #e50000;
    }
  }
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.8s ease;
}
.slide-right-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(-300px);
}
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.8s ease;
}
.slide-left-enter,
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(300px);
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
